import { extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { MediaObject as MediaObject$1 } from '@zillow/constellation';
import PropTypes from 'prop-types';
import { generateBlockList } from '../components/BlockList/BlockList.js';

var BlockMediaObject = function BlockMediaObject(_ref) {
  var attrs = _ref.attrs,
    index = _ref.index,
    innerBlocks = _ref.innerBlocks;
  var mediaBlock = innerBlocks.find(function (block) {
    return block.blockName === 'constellation/media-object-media';
  });
  var bodyBlock = innerBlocks.find(function (block) {
    return block.blockName === 'constellation/media-object-body';
  });
  // Basically remove the boolean flag if it is false, otherwise it reverses it even if prop is passed as reverse=false
  if (attrs && (typeof attrs.reverse === 'undefined' || attrs.reverse === 'false')) {
    // eslint-disable-next-line
    delete attrs.reverse;
  }
  return /*#__PURE__*/React.createElement(MediaObject$1, _extends({
    key: index,
    media: generateBlockList({
      blocks: mediaBlock.innerBlocks
    })
  }, attrs), generateBlockList({
    blocks: bodyBlock.innerBlocks
  }));
};
BlockMediaObject.propTypes = process.env.NODE_ENV !== "production" ? {
  attrs: PropTypes.shape({
    reverse: PropTypes.bool
  }),
  index: PropTypes.number,
  innerBlocks: PropTypes.arrayOf(PropTypes.shape({}))
} : {};
var MediaObject = BlockMediaObject;

export { MediaObject as default };
